import script from "./TimetableResultsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableResultsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableResultsHeader.vue?vue&type=style&index=0&id=e01d0702&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e01d0702"]])

export default __exports__